<div class="main-container">

  <app-header
    [user]="user$ | async"
    (openPowerBiModal)="showPowerBiModal = true"></app-header>

  <div class="content-container">
    <router-outlet></router-outlet>
  </div>

</div>

<app-power-bi-modal
  [showModal]="showPowerBiModal"
  (closeModal)="showPowerBiModal = false"></app-power-bi-modal>
